import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const stats = [
  { value: 120, suffix: "+", label: "Product variants across Life, Health and P&C" },
  { value: 180, suffix: "M", label: "Policies and members live on Gradatim platforms" },
  { value: 50, suffix: "%", label: "Reduction in technology costs per GWP" },
  { value: 40, suffix: "%", label: "Reduction in operating costs per GWP" },
];

const Counter = ({ to, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const dur = 1400;
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(start + (to - start) * eased));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, to]);

  return (
    <span ref={ref} className="font-display tracking-tight">
      {val}
      {suffix}
    </span>
  );
};

export const Stats = () => {
  return (
    <section data-testid="stats-section" className="relative bg-white -mt-16 md:-mt-20 z-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="bg-white border border-hairline">
          <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-hairline divide-y lg:divide-y-0">
            {stats.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ delay: i * 0.08, duration: 0.6 }}
                className="p-8 md:p-10 group"
                data-testid={`stat-${i}`}
              >
                <div className="overline text-copper mb-4">0{i + 1} / 04</div>
                <div className="text-5xl md:text-6xl text-ink leading-none">
                  <Counter to={s.value} suffix={s.suffix} />
                </div>
                <p className="mt-5 text-sm text-slate-600 leading-relaxed max-w-[14rem]">{s.label}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
